export const CHECK_MATCH = `
  query {
    checkMatch {
      id
      guard {
        id
        name
        phone
      }
      offensive {
        id
        name
        phone
      }
    }
  }
`;

export const MATCH_INFO = `
  query($id: Int!) {
    matchInfo(id: $id) {
      guardScore
      offensiveScore
      status
      guard {
        id
        name
        score
      }
      offensive {
        id
        name
        score
      }
      personal {
        rank
        score
      }
      startTime
      endTime
    }
  }
`;
